export const COMPANY_TYPES = [
  {
    value: 'SP',
    label: 'Sole Proprietorship',
  },
  {
    value: 'GP',
    label: 'General Partnership',
  },
  {
    value: 'LP',
    label: 'Limited Partnership',
  },
  {
    value: 'LLP',
    label: 'Limited Liability Partnership (LLP)',
  },
  {
    value: 'LLC',
    label: 'Limited Liability Company (LLC)',
  },
  {
    value: 'INC',
    label: 'Corporation',
  },
  {
    value: 'CCORP',
    label: 'Corporation - C Corp',
  },
  {
    value: 'SCORP',
    label: 'Corporation - S Corp',
  },
  {
    value: 'BCORP',
    label: 'Corporation - B Corp',
  },
  {
    value: 'INC',
    label: 'Incorporated (INC)',
  },
  {
    value: 'PC',
    label: 'Professional Corporation (P.C.)',
  },
  {
    value: 'NFP',
    label: 'Not For Profit (NFP)',
  },
  {
    value: 'NONE',
    label: 'Not Yet Structured',
  },
  {
    value: 'IDK',
    label: "I Don't Know",
  },
  {
    value: 'OTHER',
    label: "Other",
  }
];

export const JOB_STRUCTURES = {
  QUOTE: "QUOTE",
  HOURLY: "HOURLY",
  NO_COST: "NO_COST"
}

export const JOB_STRUCTURES_LABELS = {
  [JOB_STRUCTURES.QUOTE]: 'Fixed Price',
  [JOB_STRUCTURES.HOURLY]: 'Hourly',
  [JOB_STRUCTURES.NO_COST]: 'No Cost'
}

export const PACKAGE_NAMES = {
  LITE_HOSTING_LEGACY: 'Lite Hosting',
  E_COMMERCE_HOSTING: 'E-Commerce Hosting',
  BLOG_VLOG_HOSTING: 'Blog Hosting',
  MULTI_SITE_HOSTING: 'Multi Site Hosting',
  STANDARD_HOSTING_LEGACY: 'Standard Hosting',
  PARKED: 'Parked Site',
}

export const CHECK_IN_CYCLES = {
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  BI_YEARLY: 'Bi-Yearly',
  YEARLY: 'Yearly',
  NONE: 'None'
}

export const ARTICLES = {
  HOW_TO_GUIDES: {
    display_name: "How-to Guides",
    description:
      "Step-by-step guides that teach readers how to accomplish something clearly and confidently.",
  },
  STEP_BY_STEP_TUTORIALS: {
    display_name: "Step-by-Step Tutorials",
    description:
      "Detailed walkthroughs that show readers exactly how to complete a task or project.",
  },
  BEGINNERS_GUIDES: {
    display_name: "Beginner’s Guides",
    description:
      "Friendly introductions that explain a topic simply and clearly for new learners.",
  },
  GLOSSARIES_EXPLAINERS: {
    display_name: "Glossaries / Explainers",
    description:
      "Clear explanations and definitions that make complex ideas easy to understand.",
  },
  FAQS: {
    display_name: "Frequently Asked Questions",
    description:
      "Quick, helpful answers to common questions written in a conversational tone.",
  },
  CASE_STUDIES: {
    display_name: "Case Studies",
    description:
      "Real-world stories that highlight a challenge, solution, and measurable results.",
  },
  PROCESS_BREAKDOWNS: {
    display_name: "Process Breakdowns",
    description:
      "In-depth looks at how something works, broken into simple, logical sections.",
  },
  INDUSTRY_PREDICTIONS_TRENDS: {
    display_name: "Industry Predictions / Trends",
    description:
      "Forward-looking articles that explore upcoming trends and insights in your field.",
  },
  LESSONS_LEARNED: {
    display_name: "Lessons Learned",
    description:
      "Reflective pieces sharing key takeaways and experiences to help others grow.",
  },
  COMMENTARY_NEWS_REACTION: {
    display_name: "Commentary / News Reaction",
    description:
      "Opinion pieces that respond to current events and share thoughtful perspectives.",
  },
  BEST_PRACTICES: {
    display_name: "Best Practices / Principles",
    description:
      "Expert advice highlighting proven methods, habits, and principles that lead to success.",
  },
  ETHICAL_OR_OPINION_ESSAYS: {
    display_name: "Ethical or Opinion Essays",
    description:
      "Thoughtful essays exploring a question, opinion, or issue with insight and reasoning.",
  },
  PRODUCT_OR_SERVICE_SPOTLIGHTS: {
    display_name: "Product or Service Spotlights",
    description:
      "Features that highlight a product or service’s story, benefits, and impact.",
  },
  UPDATES_OR_ANNOUNCEMENTS: {
    display_name: "Updates or Announcements",
    description:
      "Short, timely updates that share important news or changes with your audience.",
  },
  COMPARISON_POSTS: {
    display_name: "Comparison Posts",
    description:
      "Objective comparisons that weigh pros and cons between products, tools, or ideas.",
  },
  TESTIMONIALS_CLIENT_STORIES: {
    display_name: "Testimonials / Client Stories",
    description:
      "Stories that showcase client experiences, challenges, and successes in their own words.",
  },
  BEFORE_AND_AFTER_SHOWCASES: {
    display_name: "Before and After Showcases",
    description:
      "Visual or written transformations that show improvements, progress, or results.",
  },
  EVENT_RECAPS: {
    display_name: "Event Recaps / Announcements",
    description:
      "Summaries that highlight an event’s key moments, speakers, and takeaways.",
  },
  INTERVIEWS: {
    display_name: "Interviews",
    description:
      "Q&A-style articles featuring insights, advice, and personal stories from interesting people.",
  },
  ROUNDUPS: {
    display_name: "Roundups (Businesses, Tools, or People)",
    description:
      "Curated lists featuring standout businesses, tools, or experts in one helpful article.",
  },
  COMMUNITY_SPOTLIGHTS: {
    display_name: "Community Spotlights",
    description:
      "Stories that celebrate local people, groups, or businesses making a positive impact.",
  },
  TOP_10_BEST_OF_LISTS: {
    display_name: "Top 10 / Best Of Lists",
    description:
      "Fun, ranked lists that highlight the best options, ideas, or places in a category.",
  },
};

